// extracted by mini-css-extract-plugin
export default {"component":"nbbPorEZ","timer":"S0hrutfN","text":"xdt1KlHa","icon":"kFsvZryT"};